import pica from 'pica/dist/pica';
import { IMAGE_SIZE } from 'constants';

class ImageProcessor {
  base64_size = 16;
  processor = pica();

  _getRatio = (width, height) => width / height;

  getDimensions = (r, size) => {
    if (r > 1) {
      return { width: size, height: size / r };
    }
    return { width: size * r, height: size };
  };

  fileToImg = file =>
    new Promise((resolve, reject) => {
      let img = new Image();
      let reader = new FileReader();
      reader.onload = () => {
        let blob = new Blob([reader.result], { type: file.type });
        img.src = URL.createObjectURL(blob);
      };
      img.onload = () => resolve(img);
      reader.readAsArrayBuffer(file);
    });

  refactor = async (img, size, quality) => {
    let to = document.createElement('canvas');
    const r = this._getRatio(img.width, img.height);
    const { width, height } = this.getDimensions(r, size);
    to.width = width;
    to.height = height;
    const result = await this.processor.resize(img, to);
    const blob = await this.processor.toBlob(result, 'image/jpeg', quality);
    return blob;
  };

  blobToBase64 = blob =>
    new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = function() {
        resolve(reader.result);
      };
    });

  videoToCanvas = file => {
    // var canvas = document.getElementById('canvas');
    // var video = document.getElementById('video');
    // canvas.getContext('2d').drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
  };

  process = async (file, is_base64) => {
    const img = file.thumb || (await this.fileToImg(file));
    const size = Math.min(IMAGE_SIZE.LARGE, Math.max(img.width, img.height));
    const ratio = this._getRatio(img.width, img.height);
    const { width, height } = this.getDimensions(ratio, size);
    if (is_base64) {
      const base64 = await this.blobToBase64(await this.refactor(img, IMAGE_SIZE.TINY, 0.4));
      return { width, height, base64 };
    } else {
      let blob = await this.refactor(img, size, 0.8);
      blob.width = width;
      blob.height = height;
      blob.original_uri = img.src;
      blob.uri = URL.createObjectURL(blob);
      return blob;
    }
  };
}

export const imageProcessor = new ImageProcessor();



// WEBPACK FOOTER //
// ./src/utils/image_processor.web.js